(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ke-matching-tools"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let clearArrival;
    const highlightVariant = () => {
      const id = window.location.hash.slice(1);
      if (!/^ke-variant-\d+$/.test(id)) return;
      const row = document.getElementById(id);
      if (!row || !row.matches('.kbrw tr[data-kbrw-row]')) return;
      window.clearTimeout(clearArrival);
      document.querySelectorAll('.ke-arrival').forEach(item => item.classList.remove('ke-arrival'));
      if (window.matchMedia('(max-width:749px)').matches) {
        row.classList.add('is-expanded');
        const toggle = row.querySelector('.ke-variant-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          const hideLabel = row.closest('[data-ke-hide]')?.dataset.keHide;
          if (hideLabel) toggle.textContent = hideLabel;
        }
      }
      requestAnimationFrame(() => {
        row.scrollIntoView({ behavior: 'instant', block: 'center' });
        row.setAttribute('tabindex', '-1');
        row.focus({ preventScroll: true });
        row.classList.add('ke-arrival');
        clearArrival = window.setTimeout(() => row.classList.remove('ke-arrival'), 2800);
      });
    };
    if (document.readyState === 'complete') highlightVariant();
    else window.addEventListener('load', highlightVariant, { once: true });
    window.addEventListener('hashchange', highlightVariant);
    window.addEventListener('pageshow', event => {
      if (event.persisted) highlightVariant();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ke-restock-confirmation"]) return;
  try {
    
(() => {
  const panel = document.querySelector('[data-ke-restock-confirmation]');
  if (!panel) return;
  let receipt;
  try {
    receipt = JSON.parse(sessionStorage.getItem(`ke-restock-confirmation:${location.pathname}`) || 'null');
  } catch { return; }
  const age = Date.now() - Number(receipt?.savedAt);
  if (!receipt || String(receipt.variantId) !== panel.dataset.variantId || !Number.isFinite(age) || age < 0 || age > 30 * 60 * 1000) return;
  panel.querySelector('[data-ke-confirm-fallback]').hidden = true;
  panel.querySelector('[data-ke-confirm-success]').hidden = false;
  panel.setAttribute('aria-labelledby', 'ke-confirm-title');
  if (['sent', 'pending', 'failed'].includes(receipt.confirmationStatus)) {
    panel.querySelector(`[data-ke-confirm-mail="${receipt.confirmationStatus}"]`).hidden = false;
  }
  panel.querySelector('#ke-confirm-title').focus({ preventScroll: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketools-brw-catalog-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let cartRevision = 0;
    const updateCartCount = (count) => {
      if (!Number.isInteger(count) || count < 0) return;
      document.querySelectorAll('[data-ke-cart]').forEach((link) => {
        const badge = link.querySelector('[data-ke-cart-count]');
        if (!badge) return;
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
        link.setAttribute('aria-label', `${link.dataset.keCartLabel} (${count})`);
      });
    };
    const refreshCartCount = async (cartData) => {
      const revision = ++cartRevision;
      if (Number.isInteger(cartData?.item_count)) {
        updateCartCount(cartData.item_count);
        return;
      }
      const link = document.querySelector('[data-ke-cart]');
      if (!link) return;
      try {
        const response = await fetch(link.dataset.keCartUrl, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (revision === cartRevision) updateCartCount(cart.item_count);
      } catch {}
    };
    const connectCartCounter = () => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => refreshCartCount(event?.cartData));
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', connectCartCounter, { once: true });
    } else {
      connectCartCounter();
    }
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refreshCartCount();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
